import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import localeText from "../../../../locale";
import { formatPrice } from "../../../../utilities/formatPrice";
import Shipping from "../Shipping/Shipping";
import { formatAddress } from "../ThankYouPage/ThankYouPage";
import useCheckout from "./hooks/useCheckout";
import "./Checkout.css";
import { useEffect, useRef, useState } from "react";
import { InputNumber } from "primereact/inputnumber";
import { FileUpload } from "primereact/fileupload";
import OrderService from "../../../../service/OrderService";
import { Toast } from "primereact/toast";
import CheckoutAddressDialog from "../CheckoutAddressDialog/CheckoutAddressDialog";
import { set } from "@cloudinary/url-gen/actions/variable";
import { PLATFORM_PRODUCT_FEE } from "../../../../utilities/constants";
import { Link } from "react-router-dom";
import { AdvancedImage } from "@cloudinary/react";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { Tooltip } from "primereact/tooltip";
import { useLocation } from "react-router-dom";
import ProductRow from "./ProductRow";

const Checkout = ({
  cashback,
  order,
  orderItems,
  setOrder,
  currencyProduct,
  currencyCodeUser,
  currencyUser,
  setPage,
  setAmountTransfer,
  currencyExchangeValue,
  setPrice,
  amountWallet,
  walletBalance,
  walletBalanceForex,
  price,
  amountBankTransfer,
  setAmountBankTransfer,
  bankTransferReceipt,
  setBankTransferReceipt,
  amountToPayWithExtracredit,
  setAmountToPayWithExtracredit,
  currencyCode,
  setAmountWallet,
  walletExtracoinBalance,
  userInfo,
  userPercentExtracoin,
  setAddressInfo,
  setPriceForex,
  setDisplayPaymentModal,
  sendMethod,
  setSendMethod,
  walletExtracoinBalanceForex,
  setAmountShipmentForexProduct,
  amountShipmentForexProduct,
  setLoading,
}) => {
  const {
    validateCheckout,
    loading,
    amountShipmentForexUser,
    postalCode,
    shippingQuotes,
    isFreeFreight,
    setNumber,
    number,
    setAddressValues,
    setDistrict,
    resetOrderWhenChangeAddress,
    setAddress,
    showMessageSellerResponsibility,
    country,
    checkZipCode,
    state,
    city,
    district,
    address,
    isLoadingFreight,
    setCity,
    setPostalCode,
    setState,
    toggleIsPickup,
    isPickup,
  } = useCheckout({
    order,
    setOrder,
    currencyUser,
    setPrice,
    amountWallet,
    setAmountWallet,
    amountBankTransfer,
    setAmountBankTransfer,
    bankTransferReceipt,
    setBankTransferReceipt,
    amountToPayWithExtracredit,
    setAmountToPayWithExtracredit,
    walletBalance,
    price,
    currencyCode,
    userInfo,
    setAddressInfo,
    setPriceForex,
    setDisplayPaymentModal,
    sendMethod,
    setSendMethod,
    setAmountShipmentForexProduct,
    setPage,
    setAmountTransfer,
    currencyProduct,
  });
  const orderService = new OrderService();

  const location = useLocation();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const [currentSection, setCurrentSection] = useState("address");
  const [autoCurrentSection, setAutoCurrentSection] = useState(false);

  const toast = useRef(null);
  const fileUploadRef = useRef(null);

  const [showCheckoutAddressDialog, setShowCheckoutAddressDialog] = useState(false);

  const currencyFormat = {
    USD: "$",
    EUR: "€",
    BRL: "R$",
    GBP: "£",
    JPY: "¥",
    CNY: "¥",
    AUD: "AU$",
    CAD: "CA$",
    CHF: "CHF",
  };

  const orderCurrency = isFringeBenefitsPage
    ? order.fringeBenefit.currency
    : order.itens[0].product.currency;

  const handleShowCheckoutAddressDialog = () => {
    setShowCheckoutAddressDialog(true);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCompleteForm = () => {
    if (
      address &&
      city &&
      country &&
      district &&
      number &&
      postalCode &&
      state &&
      !autoCurrentSection
    ) {
      setCurrentSection("shipping");
      setAutoCurrentSection(true);
    }
  };

  const setAddressInfoDialog = (event) => {
    setPostalCode(event.postalCode);
    setCity(event.city);
    setState(event.state);
    setDistrict(event.district);
    setAddress(event.address);
    setNumber(event.number);
    handleCompleteForm();
    /* if (
      address &&
      city &&
      country &&
      district &&
      number &&
      postalCode &&
      state &&
      !autoCurrentSection
    ) {
      return true;
    }
    return false; */
  };

  const uploadFile = async (event) => {
    if (event.files[0].size / 1024 / 1024 > 5) {
      fileUploadRef.current.clear();
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("fileSizeTooBig"),
        life: 6000,
      });
      /* setLoading(false); */
      return false;
    }
    try {
      const res = await orderService.setBankTransferReceipt(event.files[0]);
      setBankTransferReceipt(res.result);
    } catch (error) {
      console.log(error);
    }
  };

  const hasCompleteAddress = () => {
    return address && city && country && district && number && postalCode && state;
  };

  useEffect(() => {
    if (hasCompleteAddress()) {
      handleCompleteForm();
    }
  }, [address, city, country, district, number, postalCode, state]);

  useEffect(() => {
    if (!isFringeBenefitsPage) autoCurrentSection && setAddressValues(); // eslint-disable-next-line
  }, [autoCurrentSection]);

  const orderTotal = isFringeBenefitsPage ? order.totalOrder : order.amountTotal;

  const maxInputAmountWallet =
    (isFringeBenefitsPage
      ? 0
      : sendMethod?.currency !== currencyProduct
      ? amountShipmentForexProduct
      : order.amountShipment) +
    orderTotal -
    amountToPayWithExtracredit;

  const walletBalanceValue =
    currencyCodeUser !== orderCurrency ? walletBalanceForex : walletBalance;

  const maxInputAmountExtracredit =
    (isFringeBenefitsPage
      ? 0
      : sendMethod?.currency !== currencyProduct
      ? amountShipmentForexProduct
      : order.amountShipment) +
    orderTotal -
    amountWallet;

  const maxInputAmountBankTransfer =
    (isFringeBenefitsPage
      ? 0
      : sendMethod?.currency !== currencyProduct
      ? amountShipmentForexProduct
      : order.amountShipment) +
    orderTotal -
    amountWallet -
    amountToPayWithExtracredit;

  let extracoinInWallet;

  if (walletExtracoinBalanceForex) {
    extracoinInWallet = walletExtracoinBalanceForex * (userPercentExtracoin / 100);
  } else {
    extracoinInWallet = walletExtracoinBalance * (userPercentExtracoin / 100);
  }

  const anyProductIsPickup = order?.itens?.some(
    (product) => product?.product?.shippingOption === "PICKUP"
  );
  const totarPrice =
    currencyProduct +
    " " +
    formatPrice(
      Math.abs(
        (isFringeBenefitsPage
          ? 0
          : sendMethod?.currency !== currencyProduct
          ? amountShipmentForexProduct
          : order.amountShipment) +
          orderTotal -
          amountWallet -
          amountToPayWithExtracredit
      )
    );

  return (
    <div className="pt-4 pb-8">
      <Toast ref={toast} />
      {country && (
        <CheckoutAddressDialog
          country={country}
          visible={showCheckoutAddressDialog}
          checkZipCode={checkZipCode}
          onHide={() => setShowCheckoutAddressDialog(false)}
          onSubmit={setAddressInfoDialog}
        />
      )}

      <div
        className="font-bold text-xl my-3 flex gap-2 align-items-center justify-content-between"
        style={{ color: "#344563" }}
      >
        {localeText("confirmation")}{" "}
        <Button
          link
          className=" p-no-outline flex gap-2 align-items-center"
          style={{ color: "#245AE5" }}
          onClick={() => setPage(1)}
        >
          <i className="pi pi-arrow-left text-xs"></i>{" "}
          <span className="underline">{localeText("backAction")}</span>
        </Button>
      </div>

      <div className="grid grid-nogutter gap-4">
        <div className="col-12 md:col-8 ">
          {!isFringeBenefitsPage &&
            !order.itens[0].product.downloadable &&
            !order.itens[0].product.service && (
              <div
                className="card p-4 border-round-lg border-none flex flex-column gap-3 mb-4"
                style={{ boxShadow: "0px 0px 40px  #5F58521A" }}
              >
                {!hasCompleteAddress() && (
                  <div className="flex flex-column gap-3">
                    <div className="font-bold" style={{ color: "#344563" }}>
                      {localeText("shipToMyAddress")}
                    </div>
                    <div className="flex justify-content-between">
                      <div className="flex gap-2 align-items-center">
                        <i className="pi pi-exclamation-circle" style={{ color: "#B3BAC5" }}></i>{" "}
                        <span className="text-sm" style={{ color: "#505F79" }}>
                          {localeText("youDontHaveAddress")}
                        </span>
                      </div>
                      <Button
                        link
                        label="+ Adicionar um endereço"
                        onClick={handleShowCheckoutAddressDialog}
                      />
                    </div>
                  </div>
                )}

                <div>
                  {hasCompleteAddress() && !isPickup && (
                    <div className="flex flex-column gap-3">
                      <div className="font-bold" style={{ color: "#344563" }}>
                        {localeText("shipToMyAddress")}
                      </div>
                      <div className="flex flex-column gap-2">
                        <div className="flex gap-2 align-items-center">
                          <i className="pi pi-home" style={{ color: "#B3BAC5" }}></i>{" "}
                          <span className="text-sm" style={{ color: "#505F79" }}>
                            {address}
                          </span>
                        </div>
                        <div className="flex gap-2 align-items-center">
                          <i className="pi pi-map-marker" style={{ color: "#B3BAC5" }}></i>{" "}
                          <span className="text-sm" style={{ color: "#505F79" }}>
                            {city}, {state}, {country}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}

                  {anyProductIsPickup && (
                    <div>
                      {!isPickup && <hr></hr>}

                      <div className="flex align-items-center">
                        <Checkbox
                          inputId="ingredient1"
                          name="pizza"
                          value="Cheese"
                          onChange={toggleIsPickup}
                          checked={isPickup}
                        />
                        <label htmlFor="ingredient1" className="ml-2">
                          {localeText("pickUpInStore")}
                        </label>
                      </div>
                      {isPickup && (
                        <div className="text-sm mt-2">{formatAddress(order.seller)}</div>
                      )}
                    </div>
                  )}
                </div>
                {currentSection === "shipping" && !isPickup && (
                  <div>
                    <Button
                      className="text-sm border-none px-0"
                      link
                      onClick={() => {
                        setAddressValues();
                      }}
                      disabled={isLoadingFreight}
                      label={
                        isLoadingFreight
                          ? localeText("lookingTheBestShippingMethod")
                          : localeText("searchForShipping")
                      }
                    />
                    <div>
                      {isFreeFreight && (
                        <div className="text-sm" style={{ color: "#344563" }}>{`${localeText(
                          "freight"
                        )}: ${localeText("free")}`}</div>
                      )}
                      {showMessageSellerResponsibility && (
                        <div className="text-sm" style={{ color: "#344563" }}>
                          {localeText("shippingResponsibilitySeller")}
                        </div>
                      )}
                      {/* Shipping component */}
                      {!isFringeBenefitsPage &&
                        !order.itens[0].product.service &&
                        !order.itens[0].product.downloadable &&
                        shippingQuotes &&
                        !isPickup && (
                          <Shipping
                            shippingQuotes={shippingQuotes}
                            postalCode={postalCode}
                            sendMethod={sendMethod}
                            setSendMethod={setSendMethod}
                          />
                        )}
                    </div>
                  </div>
                )}
              </div>
            )}

          <div
            className="card p-4 border-round-lg border-none"
            style={{ boxShadow: "0px 0px 40px  #5F58521A" }}
          >
            <div className="flex flex-column gap-4">
              {isFringeBenefitsPage ? (
                <ProductRow index={0} item={order} orderItems={[]} />
              ) : (
                <>
                  {orderItems.map((item, index) => (
                    <ProductRow key={index} index={index} item={item} orderItems={orderItems} />
                  ))}
                </>
              )}
            </div>
          </div>
        </div>

        <div className={"col-12 md:col flex flex-column gap-2"}>
          <div
            className="card p-4 border-round-lg border-none"
            style={{ boxShadow: "0px 0px 40px  #5F58521A" }}
          >
            <div className="font-bold uppercase" style={{ color: "#344563" }}>
              <div className="my-0">{localeText("orderResume")}</div>
            </div>
            <hr />
            <div className="flex flex-column gap-2">
              {!isFringeBenefitsPage &&
                !order.itens[0].product.service &&
                !order.itens[0].product.downloadable &&
                sendMethod &&
                shippingQuotes && (
                  <div className="flex justify-content-between align-items-center gap-3">
                    <span>
                      {localeText("shippingCost")}
                      {showMessageSellerResponsibility && (
                        <p className="text-sm font-bold mb-1">
                          *{localeText("shippingResponsibilitySeller")}
                        </p>
                      )}
                    </span>
                    <span className="text-right">
                      <b>
                        {currencyProduct} {formatPrice(order.amountShipment)}
                        {amountShipmentForexUser > 0 && (
                          <span className="text-600 text-right">
                            {" "}
                            (≈ {currencyUser}{" "}
                            {formatPrice(order.amountShipment / currencyExchangeValue)})
                          </span>
                        )}
                      </b>
                    </span>
                  </div>
                )}

              <div
                className="flex flex-column gap-2 text-sm font-medium"
                style={{ color: "#505F79" }}
              >
                <div className="flex justify-content-between">
                  <span>{localeText("subtotal")}</span>
                  <span className="font-normal" style={{ color: "#091E42" }}>
                    {currencyFormat[currencyProduct]}{" "}
                    {formatPrice(isFringeBenefitsPage ? orderTotal : order.amountOrder)}
                  </span>
                </div>

                {!isFringeBenefitsPage && (
                  <div className="flex justify-content-between">
                    <div className="">
                      <span>{localeText("platformFee")}</span>
                      <Tooltip target=".extracoin-tooltip" position="bottom" />
                      <i
                        className="pi pi-info-circle ml-1 extracoin-tooltip cursor-pointer text-600 align-self-start gap-0"
                        data-pr-tooltip={localeText("plataformFeeExplanation")}
                        data-pr-position="right"
                        data-pr-at="right+5 top"
                        data-pr-my="left center-2"
                        tooltipoptions={{ event: "focus" }}
                      />
                    </div>
                    <span className="font-normal" style={{ color: "#091E42" }}>
                      {currencyFormat[currencyProduct]} {formatPrice(order.amountToPlatform)}
                    </span>
                  </div>
                )}
              </div>

              <>
                <div className="flex flex-column">
                  <hr className="mb-0" />
                  <span
                    className="text-xs font-normal px-2 py-1 w-fit"
                    style={{ color: "#253858", backgroundColor: "#EBECF0" }}
                  >
                    {localeText("yourCredits")}
                  </span>
                </div>

                <div
                  className="flex flex-column gap-2 mb-3 mt-2 text-sm font-medium"
                  style={{ color: "#505F79" }}
                >
                  <div className="flex justify-content-between">
                    <span>{localeText("balanceAvailable")}</span>
                    <span className="font-normal text-right" style={{ color: "#46A748" }}>
                      + {currencyFormat[currencyProduct]}{" "}
                      {formatPrice(
                        parseFloat(walletExtracoinBalance * (userPercentExtracoin / 100))
                      )}
                      {currencyCodeUser !== orderCurrency && (
                        <>
                          {" "}
                          (≈ {currencyFormat[currencyProduct]}{" "}
                          {formatPrice(
                            parseFloat(walletExtracoinBalanceForex * (userPercentExtracoin / 100))
                          )}
                          )
                        </>
                      )}
                    </span>
                  </div>
                  <div className="flex justify-content-between">
                    <span>{localeText("walletBalance")}</span>
                    <span className="font-normal text-right" style={{ color: "#46A748" }}>
                      + {currencyFormat[currencyProduct]} {formatPrice(walletBalance)}
                    </span>
                  </div>
                </div>
              </>
            </div>
            {/* <br />
            <div className="text-justify">
              <i className="sm:text-base text-sm text-green-500">
                {localeText("extraconomyExplain")}
              </i>
            </div> */}
            <br />
            <div className="flex flex-column gap-4">
              {walletExtracoinBalance > 0 && (
                <div className="flex flex-column justify-content-between gap-2 w-full">
                  <label className="flex align-items-center" htmlFor="extracredit">
                    {localeText("amountToPayWithExtracredit")}
                  </label>
                  <div className={"flex align-items-center xl:flex-row gap-2 w-full"}>
                    <span className="text-600">{currencyProduct}</span>
                    <InputNumber
                      className={"input-amount"}
                      style={{ width: "100%" }}
                      value={amountToPayWithExtracredit}
                      onChange={(e) => {
                        setLoading(true);
                        const maxValue =
                          maxInputAmountExtracredit < extracoinInWallet
                            ? maxInputAmountExtracredit
                            : extracoinInWallet;

                        const shipmentePrice = isFringeBenefitsPage
                          ? 0
                          : sendMethod?.currency !== currencyProduct
                          ? amountShipmentForexProduct
                          : order.amountShipment;

                        const priceWithShip =
                          shipmentePrice > 0 ? orderTotal + shipmentePrice : orderTotal;

                        const priceToPay = parseFloat(priceWithShip.toFixed(2));

                        const inputValue =
                          e.value && e.value < maxValue
                            ? parseFloat(e.value)
                            : e.value
                            ? maxValue
                            : 0;

                        setOrder((prev) => ({ ...prev, amountWalletExtracoin: inputValue }));

                        setPrice(
                          parseFloat(
                            Math.abs(
                              priceToPay - inputValue - amountWallet - amountBankTransfer
                            ).toFixed(2)
                          )
                        );
                        if (!inputValue) {
                          setAmountToPayWithExtracredit(0);
                        } else {
                          const amountExtracredit = parseFloat(parseFloat(inputValue).toFixed(2));

                          setAmountToPayWithExtracredit(amountExtracredit);
                        }
                        setLoading(false);
                      }}
                      max={
                        maxInputAmountExtracredit < extracoinInWallet
                          ? maxInputAmountExtracredit
                          : extracoinInWallet
                      }
                      minFractionDigits={2}
                      maxFractionDigits={2}
                    />
                  </div>
                </div>
              )}

              {walletBalanceValue > 0 && (
                <div className="flex flex-column justify-content-between gap-2 w-full">
                  <label className="flex align-items-center" htmlFor="wallet">
                    {localeText("amountToPayWithWalletBalance")}
                  </label>
                  <div className={"flex align-items-center xl:flex-row gap-2 w-full"}>
                    <span className="text-600">{currencyProduct}</span>
                    <InputNumber
                      className={"input-amount"}
                      style={{ width: "100%" }}
                      value={amountWallet}
                      onChange={(e) => {
                        setLoading(true);
                        const maxValueInWallet =
                          maxInputAmountWallet <= walletBalanceValue
                            ? maxInputAmountWallet
                            : walletBalanceValue;

                        const shipmentePrice = isFringeBenefitsPage
                          ? 0
                          : sendMethod?.currency !== currencyProduct
                          ? amountShipmentForexProduct
                          : order.amountShipment;

                        const priceWithShip =
                          shipmentePrice > 0 ? orderTotal + shipmentePrice : orderTotal;

                        const priceToPay = parseFloat(priceWithShip.toFixed(2));

                        const inputValue =
                          e.value && e.value <= maxValueInWallet
                            ? parseFloat(e.value)
                            : e.value
                            ? maxValueInWallet
                            : 0;

                        setOrder((prev) => ({ ...prev, amountWallet: inputValue }));

                        setAmountWallet(inputValue);

                        setPrice(
                          parseFloat(
                            Math.abs(
                              priceToPay -
                                inputValue -
                                amountToPayWithExtracredit -
                                amountBankTransfer
                            ).toFixed(2)
                          )
                        );
                        if (!inputValue) {
                          setAmountWallet(0);
                        } else {
                          const amountWallet_ = parseFloat(parseFloat(inputValue).toFixed(2));
                          setAmountWallet(amountWallet_);
                        }
                        setLoading(false);
                      }}
                      max={
                        maxInputAmountWallet <= walletBalanceValue
                          ? maxInputAmountWallet
                          : walletBalanceValue
                      }
                      minFractionDigits={2}
                      maxFractionDigits={2}
                    />
                  </div>
                </div>
              )}

              <div className="flex flex-column justify-content-between gap-2 w-full">
                <label className="flex align-items-center" htmlFor="bankTransfer">
                  {localeText("payWithBankTransfer")}
                </label>
                <div className={"flex align-items-center xl:flex-row gap-2 w-full"}>
                  <span className="text-600">{currencyProduct}</span>
                  <InputNumber
                    className={"input-amount"}
                    style={{ width: "100%" }}
                    value={amountBankTransfer}
                    onChange={(e) => {
                      setLoading(true);
                      const maxValue = maxInputAmountBankTransfer;

                      const shipmentPrice = isFringeBenefitsPage
                        ? 0
                        : sendMethod?.currency !== currencyProduct
                        ? amountShipmentForexProduct
                        : order.amountShipment;

                      const priceWithShip =
                        shipmentPrice > 0 ? orderTotal + shipmentPrice : orderTotal;

                      const priceToPay = parseFloat(priceWithShip.toFixed(2));

                      const inputValue =
                        e.value && e.value > 0 ? Math.min(parseFloat(e.value), maxValue) : 0;

                      setOrder((prev) => ({ ...prev, amountBankTransfer: inputValue }));

                      const remainingPrice = Math.max(
                        0,
                        parseFloat(
                          (
                            priceToPay -
                            inputValue -
                            amountWallet -
                            amountToPayWithExtracredit
                          ).toFixed(2)
                        )
                      );

                      setPrice(remainingPrice);
                      setAmountBankTransfer(inputValue ? parseFloat(inputValue).toFixed(2) : 0);
                      setLoading(false);
                    }}
                    max={maxInputAmountBankTransfer}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                  />
                </div>

                {amountBankTransfer > 0 ? (
                  <div>
                    <div className="my-3">
                      <div className="text-md" style={{ color: "#505F79" }}>
                        {localeText("transferToThisBank")}
                        <ul style={{ lineHeight: "1.6" }}>
                          <li>
                            {localeText("value")}:{" "}
                            <b>
                              {currencyFormat[currencyProduct]} {amountBankTransfer}
                            </b>
                          </li>
                          <li>
                            {localeText("bank")}: <b>BPM</b>
                          </li>
                          <li style={{ wordBreak: "break-all" }}>
                            IBAN: <b>IT78F0503403268000000024931</b>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div>
                      <FileUpload
                        name="bankTransferReceipt"
                        auto
                        customUpload
                        uploadHandler={uploadFile}
                        ref={fileUploadRef}
                        accept="image/*"
                        maxFileSize={1000000}
                        emptyTemplate={
                          <p className="m-0 text-xl flex items-center gap-2">
                            <i className="pi pi-cloud-upload" style={{ fontSize: "1.5rem" }}></i>{" "}
                            {localeText("sendYourTransferReceipt")}.
                          </p>
                        }
                      />
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <br />
            <hr></hr>
            <div className="flex justify-content-between">
              <span className="text-sm font-medium" style={{ color: "#505F79" }}>
                {" "}
                {localeText("total")}
              </span>
              <span style={{ color: "#46A748" }} className="text-right">
                <b>
                  {currencyFormat[currencyProduct]}{" "}
                  {formatPrice(
                    isFringeBenefitsPage
                      ? orderTotal
                      : Math.abs(
                          (sendMethod?.currency !== currencyProduct
                            ? amountShipmentForexProduct
                            : order.amountShipment) +
                            order.amountTotal -
                            amountWallet -
                            amountToPayWithExtracredit -
                            amountBankTransfer
                        )
                  )}
                </b>
              </span>
            </div>

            <div className="text-right my-4">
              <p className="text-sm font-light" style={{ color: "#7A869A" }}>
                {localeText("paypalPayment")}
              </p>
            </div>
            {cashback > 0 && (
              <div className="flex justify-content-center align-items-center gap-2 text-green-500 mb-3">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.53123 0.761804C9.40167 0.631921 9.19074 0.630294 9.05988 0.760176L7.74217 2.06942L7.70794 2.10927C7.66678 2.16561 7.64386 2.23394 7.64386 2.30477C7.64386 2.39299 7.67837 2.47795 7.74087 2.54078L9.08982 3.89755L9.14213 3.94051C9.19761 3.97736 9.2617 3.99585 9.32615 3.99585C9.41144 3.99585 9.49607 3.96363 9.56118 3.89885C9.69204 3.76897 9.69204 3.55803 9.56248 3.42749L8.78554 2.64624L8.93249 2.65477C10.8328 2.80285 12.3346 4.3925 12.3346 6.33016C12.3346 6.51441 12.4837 6.6635 12.6679 6.6635C12.8522 6.6635 13.0013 6.51441 13.0013 6.33016C13.0013 3.97274 11.1191 2.05148 8.77887 1.97925L9.52993 1.23316L9.56855 1.18718C9.6588 1.05771 9.64697 0.878123 9.53123 0.761804ZM7.33331 4.16683C7.33331 2.23682 5.763 0.666829 3.83331 0.666829C1.90363 0.666829 0.333313 2.23682 0.333313 4.16683C0.333313 6.09684 1.90363 7.66683 3.83331 7.66683C5.763 7.66683 7.33331 6.09684 7.33331 4.16683ZM10.1666 7.00016C12.0963 7.00016 13.6666 8.57015 13.6666 10.5002C13.6666 12.4302 12.0963 14.0002 10.1666 14.0002C8.23696 14.0002 6.66665 12.4302 6.66665 10.5002C6.66665 8.57015 8.23696 7.00016 10.1666 7.00016ZM1.33331 8.00016C1.51756 8.00016 1.66665 8.14925 1.66665 8.3335C1.66665 10.2712 3.16848 11.8608 5.06877 12.0089L5.21572 12.0174L4.43878 11.2362C4.30922 11.1056 4.30922 10.8947 4.44008 10.7648C4.5564 10.6494 4.73548 10.637 4.86529 10.7274L4.91144 10.7661L6.2604 12.1229C6.3229 12.1857 6.3574 12.2707 6.3574 12.3589C6.3574 12.4297 6.33449 12.4981 6.29332 12.5544L6.25909 12.5942L4.94139 13.9035C4.87628 13.9679 4.791 14.0002 4.70636 14.0002C4.62042 14.0002 4.53514 13.9673 4.47003 13.9019C4.35429 13.7855 4.34246 13.6059 4.43271 13.4765L4.47133 13.4305L5.22239 12.6844C2.88218 12.6122 0.99998 10.6909 0.99998 8.3335C0.99998 8.14925 1.14907 8.00016 1.33331 8.00016ZM7.33331 10.5002C7.33331 8.93799 8.60415 7.66683 10.1666 7.66683C11.7291 7.66683 13 8.93799 13 10.5002C13 12.0623 11.7291 13.3335 10.1666 13.3335C8.60415 13.3335 7.33331 12.0623 7.33331 10.5002ZM10.1549 8.12614C10.3187 8.12614 10.4547 8.24394 10.4829 8.39952L10.4883 8.45947V8.71794C10.6539 8.75359 10.8028 8.80546 10.9213 8.85455L11.0481 8.91092L11.1721 8.97453L11.2031 8.99235C11.36 9.0874 11.4101 9.2915 11.3157 9.44873C11.2313 9.58936 11.0603 9.64382 10.9128 9.58903L10.7602 9.51175L10.6511 9.46332C10.5052 9.40363 10.2992 9.33936 10.0892 9.33936C9.82681 9.33936 9.55533 9.45296 9.55533 9.64339C9.55533 9.84281 9.78047 9.97534 10.1404 10.1264L10.5235 10.2807L10.7005 10.3568C11.112 10.5441 11.4967 10.8074 11.4967 11.3075C11.4967 11.7131 11.2556 12.1416 10.6134 12.2803L10.4883 12.3028V12.5409C10.4883 12.7251 10.3392 12.8742 10.1549 12.8742C9.99116 12.8742 9.85517 12.7564 9.82697 12.6008L9.8216 12.5409V12.3031C9.4517 12.2522 9.20328 12.1226 9.06387 12.027L8.98695 11.9695L8.93033 11.9185C8.80207 11.7863 8.80598 11.575 8.93814 11.4471C9.05677 11.3345 9.23611 11.3244 9.36412 11.4163L9.42695 11.4695L9.47678 11.5029C9.57658 11.5632 9.79095 11.6597 10.1439 11.6597C10.4004 11.6597 10.8301 11.6138 10.8301 11.3075C10.8301 11.1754 10.6609 11.0678 10.3972 10.9515L10.2082 10.8722L9.93028 10.7611L9.75257 10.685C9.30904 10.4849 8.88866 10.2013 8.88866 9.64339C8.88866 9.18666 9.22236 8.8326 9.71995 8.71539L9.8216 8.69515V8.45947C9.8216 8.27523 9.97069 8.12614 10.1549 8.12614ZM3.83331 1.3335C2.27081 1.3335 0.99998 2.60466 0.99998 4.16683C0.99998 5.729 2.27081 7.00016 3.83331 7.00016C5.39581 7.00016 6.66665 5.729 6.66665 4.16683C6.66665 2.60466 5.39581 1.3335 3.83331 1.3335ZM4.15753 4.46989C4.34178 4.46989 4.49087 4.61898 4.49087 4.80322C4.49087 4.967 4.37307 5.10299 4.21749 5.13119L4.15753 5.13656H2.93528C3.17067 5.48832 3.50958 5.65771 3.97915 5.65771C4.36652 5.65771 4.55467 5.54541 4.86326 5.30713C5.00779 5.1945 5.21873 5.22054 5.33071 5.36768C5.44334 5.51351 5.41665 5.72282 5.27081 5.83512C4.92316 6.1027 4.58657 6.32438 3.97915 6.32438C3.184 6.32438 2.59189 5.95672 2.24267 5.26246L2.18357 5.13656H1.85805C1.67381 5.13656 1.52472 4.98747 1.52472 4.80322C1.52472 4.63945 1.64252 4.50345 1.7981 4.47526L1.85805 4.46989H4.15753ZM5.27081 2.49854C4.92316 2.23096 4.58657 2.00928 3.97915 2.00928C3.06415 2.00928 2.41494 2.49207 2.0991 3.40413H1.85805L1.7981 3.4095C1.64252 3.4377 1.52472 3.57369 1.52472 3.73747C1.52472 3.92171 1.67381 4.0708 1.85805 4.0708H4.15753L4.21749 4.06544C4.37307 4.03724 4.49087 3.90124 4.49087 3.73747C4.49087 3.55322 4.34178 3.40413 4.15753 3.40413H2.83217L2.88441 3.30401C3.11951 2.8861 3.46963 2.67594 3.97915 2.67594C4.36652 2.67594 4.55467 2.78825 4.86326 3.02653C5.00909 3.13916 5.21938 3.11279 5.33071 2.96598C5.44334 2.82015 5.41665 2.61084 5.27081 2.49854Z"
                    fill="#28AB69"
                  />
                </svg>
                <span className="text-sm">Cashback extracredit</span>
                <span className="text-sm">
                  <b>
                    {currencyFormat[currencyProduct]} {formatPrice(cashback)}
                  </b>
                </span>
              </div>
            )}

            {((!order?.itens?.[0]?.product?.downloadable && !order?.itens?.[0]?.product?.service) ||
              !order?.fringeBenefit) && (
              <div className="flex">
                {price > 0 ? (
                  <Button
                    className="w-full border-none border-round-lg px-4 py-3 uppercase text-white font-semibold"
                    style={{ backgroundColor: "#28AB69" }}
                    label={localeText("proceedToPayment")}
                    onClick={() => validateCheckout(false)}
                    loading={loading}
                    disabled={amountBankTransfer && !bankTransferReceipt}
                  />
                ) : (
                  <Button
                    className="w-full border-none border-round-lg px-4 py-3 uppercase text-white font-semibold"
                    style={{ backgroundColor: "#28AB69" }}
                    label={localeText("finishOrder")}
                    onClick={() => validateCheckout(true)}
                    loading={loading}
                    disabled={amountBankTransfer && !bankTransferReceipt}
                  />
                )}
              </div>
            )}
            {!isFringeBenefitsPage &&
              (order.itens[0].product.downloadable || order.itens[0].product.service) && (
                <div className="flex">
                  {price > 0 ? (
                    <Button
                      className="w-full border-none border-round-lg px-4 py-3 uppercase text-white font-semibold"
                      label={localeText("proceedToPayment")}
                      style={{ backgroundColor: "#28AB69" }}
                      onClick={() => validateCheckout(false)}
                      loading={loading}
                      disabled={amountBankTransfer && !bankTransferReceipt}
                    />
                  ) : (
                    <Button
                      className="w-full border-none border-round-lg px-4 py-3 uppercase text-white font-semibold"
                      label={localeText("finishOrder")}
                      style={{ backgroundColor: "#28AB69" }}
                      onClick={() => validateCheckout(true)}
                      loading={loading}
                      disabled={amountBankTransfer && !bankTransferReceipt}
                    />
                  )}
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
